<template>
    <md-table class="az-table">
        <md-table-row v-if="headers">
            <md-table-cell v-if="primary" class="title" :rowspan="getRowSpan" width="15%">{{primary}}</md-table-cell>
            <md-table-cell v-for="(item, index) in headers" :key="index" class="gray">{{headers[index]}}</md-table-cell>
        </md-table-row>
        <template v-for="(row, index) in dataFormated">
            <md-table-row :key="'row-'+index" :class="getClass(index)">
                <md-table-cell
                    class="az-first-cell"
                    :class="{ 'is-expandable': hasChildren(index) }"
                >
                    <div class="az-cell-click" @click="toggleRow(index)">
                        <span>
                        {{ row[0] }}

                        <span v-if="hasChildren(index)" class="az-caret">
                            <SvgIcon
                            v-if="isExpanded(index)"
                            type="mdi"
                            :path="icons.down"
                            />
                            <SvgIcon
                            v-else
                            type="mdi"
                            :path="icons.right"
                            />
                        </span>
                    </span>
                    </div>
                </md-table-cell>

                <md-table-cell>{{ row[1] }}</md-table-cell>
            </md-table-row>

            <md-table-row v-if="hasChildren(index) && isExpanded(index)" :key="'details-'+index" class="az-details-row">
                <md-table-cell :colspan="2" class="az-details-cell">
                    <md-table class="az-table az-subtable">
                        <md-table-row v-for="(child, cIndex) in getChildren(index)" :key="cIndex">
                            <md-table-cell class="az-subtitle">{{ child[0] }}</md-table-cell>
                            <md-table-cell>{{ child[1] }}</md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-table-cell>
            </md-table-row>
        </template>
    </md-table>
    
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowDownThick, mdiArrowRightThick } from '@mdi/js';

export default {
    name: 'az-table',
    props:['headers','data','primary'],
    data() {
        return {
            expandedRows: {},
            icons: {
                right: mdiArrowRightThick,
                down: mdiArrowDownThick
            }
        };
    },
    components: {
        SvgIcon
    },
    computed: {
        getRowSpan() {
            // falta calcular
            return 10;
        },
        dataFormated() {
            // Remove ONLY the last column (paint flag) from each row.
            // Keep optional children array in the row.
            let dataClone = [];
            for (let key in this.data) {
                let copy = this.data[key].slice(0);
                copy.pop();
                dataClone[key] = copy;
            }
            return dataClone;
        }
    },
    methods: {
        getClass(index) {
            const row = this.data && this.data[index] ? this.data[index] : null;
            if (!row || !row.length) return '';
            const paintFlag = row[row.length - 1];
            return paintFlag == 1 ? 'gray' : '';
        },
        // Convention: last element is paint flag; the element before it can be children array.
        hasChildren(index) {
            const row = this.data && this.data[index] ? this.data[index] : null;
            if (!row || row.length < 3) return false;
            const maybeChildren = row[row.length - 2];
            return Array.isArray(maybeChildren) && maybeChildren.length > 0;
        },
        getChildren(index) {
            const row = this.data && this.data[index] ? this.data[index] : null;
            if (!row || row.length < 3) return [];
            const maybeChildren = row[row.length - 2];
            return Array.isArray(maybeChildren) ? maybeChildren : [];
        },
        toggleRow(index) {
            if (!this.hasChildren(index)) return;

            const next = !this.isExpanded(index);

            // Vue 2 & Vue 3 safe: avoid this.$set
            this.expandedRows = { ...this.expandedRows, [index]: next };
        },
        isExpanded(index) {
            return this.expandedRows && this.expandedRows[index] === true;
        }
    }
}
</script>
<style>
.az-table{
    border:1px solid #ddd;
    max-height: 400px;
    overflow: hidden;

}
.az-table .title{
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #ddd;
}
.az-table .gray{
    background-color: #ddd;
    font-weight: bold;
}

.az-table .md-table-cell{
    padding: 5px;
    font-size:12px;
    height: 10px;
    max-height: 10px;
}

.az-table .az-first-cell, .az-table .md-table-cell .az-subtitle{
    width: 48%;
}

.az-table .az-first-cell.is-expandable{
    cursor: pointer;
    user-select: none;
}

.az-table .az-caret {
    display: inline-flex;
    vertical-align: middle;
}
.az-table .az-caret svg{
    color: #000;
    height: 14px;
}
.az-details-row .az-details-cell{
    padding: 0;
}
.az-subtable{
    border: none;
}
/* .az-subtable .md-table-cell{
    padding: 6px 8px;
    font-size: 12px;
} */
.az-subtitle{
    font-weight: bold;
    padding-left: 1rem !important;
}
.az-cell-click{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
</style>
